export default __webpack_public_path__ + "static/Fellix-Regular-43519b834608f5f57e0c65e011b6e8b0.eot";